function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagLT(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURf7BRP28N9MyOwxuSMsuNw12TcMrMw99UhCCVVXXS3EAAAEaSURBVDjL5YyxasUwDEWVP4j/oBR/wAPjPQSjOWBM1jcYz1lCMnZLP7uS7Lih7yVdSin0YEv3StcG+A+0oFrVtBXScnYUQO6NUnXZVscFFNMoeiy9OpL8kAJ5WLby8Ej54ZxfCbxf8/Y1sD4Elues67Zxn2DZsuLhssldDn46+2GnBMZxLANWu2E9QRDGUJnDUQ9Au7nMWc05nRvVAcI1A3giBEvaCyStZW/FDiDdeGOMLxhr2XvL3MAwNPHWFHwp0kvgnJ8IvF7z8icCTuu+1zrXXX3qDrTrHd9cXVYktBZDP2T6w61QpgN3TQeRKspxLGtB2WMHiBhjooNy+cSIxcR4B0x1l1KOICnMigKpQoOisKp0DDzl+8AHJgoxopyy+xoAAAAASUVORK5CYII=",
    alt: "LT"
  }, props));
}